import { Swiper, Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);

class GalleryCarousel {
	constructor(carousel) {
		// The main swiper container for this block
		const mainCarousel = carousel.querySelector('.block-gallery-carousel__main');
		if (!mainCarousel) return;

		// Arrows
		const arrowNext =
			mainCarousel.querySelector('.swiper-button-next') ||
			carousel.querySelector('.swiper-button-next');

		const arrowPrev =
			mainCarousel.querySelector('.swiper-button-prev') ||
			carousel.querySelector('.swiper-button-prev');

		// Pagination element (dots) – scoped to this carousel
		const paginationEl =
			mainCarousel.querySelector('.swiper-pagination') ||
			carousel.querySelector('.swiper-pagination');

		this.swiper = new Swiper(mainCarousel, {
			loop: true,
			spaceBetween: 10,
			centeredSlides: true,
			slidesPerView: 1, // mobile
			breakpointsBase: 'window',

			// Responsive breakpoints
			breakpoints: {
				990: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1324: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				
			},

			// Only enable navigation if we found the buttons
			navigation: arrowNext && arrowPrev ? {
				nextEl: arrowNext,
				prevEl: arrowPrev,
			} : {},

			// Only enable pagination if we found the element
			pagination: paginationEl ? {
				el: paginationEl,
				clickable: true,
				type: 'bullets',
			} : {},
		});

		// Uniform slide heights across browsers (Firefox/Safari)
		const MAIN_RATIO = 609 / 857;
		const setUniformHeights = () => {
			const slides = mainCarousel.querySelectorAll('.swiper-slide');
			slides.forEach((slide) => {
				const w = slide.clientWidth || slide.offsetWidth;
				if (w > 0) {
					const h = Math.round(w * MAIN_RATIO);
					slide.style.height = h + 'px';

					// Ensure descendants fill the slide box in all browsers
					slide.querySelectorAll('picture, img').forEach((el) => {
						el.style.width = '100%';
						el.style.height = '100%';
						el.style.display = 'block';
						// object-fit only applies to replaced content (img), harmless on picture
						if (el.tagName.toLowerCase() === 'img') {
							el.style.objectFit = 'cover';
							el.style.objectPosition = 'top center';
						}
					});
				}
			});
		};

		// Run initially and on layout changes
		setUniformHeights();
		window.addEventListener('resize', setUniformHeights, { passive: true });
		this.swiper.on('resize', setUniformHeights);
		this.swiper.on('transitionEnd', setUniformHeights);
		this.swiper.on('breakpoint', setUniformHeights);

		// Recalculate when images load (lazy sizes can shift layout)
		mainCarousel.querySelectorAll('img').forEach((img) => {
			if (!img.complete) {
				img.addEventListener('load', setUniformHeights, { once: true });
			}
		});

		// Observe size changes to the container (e.g., fonts, layout shifts)
		if (window.ResizeObserver) {
			const ro = new ResizeObserver(() => setUniformHeights());
			ro.observe(mainCarousel);
		}
	}
}

export default GalleryCarousel;